{
  "common": {
    "dateTbc": "Date TBC",
    "cancelled": "cancelled"
  },
  "dashboard": {
    "eventConfirmed": "confirmed",
    "eventPending": "pending",
    "eventNotApproved": "not approved",
    "eventOpen": "open"
  },
  "payments": {
    "outstanding": "Outstanding",
    "itemsDue": "Items due",
    "creditBalance": "Credit balance",
    "creditNote": "Your credit is automatically applied to upcoming payments.",
    "dueLabel": "Due {date}",
    "overdue": "overdue",
    "pay": "Pay",
    "payNoteOnline": "Pay securely by card, or in person / by bank transfer (the school will mark those as paid).",
    "payNoteOffline": "Pay in person or by bank transfer — the school will mark these as paid.",
    "allPaidUp": "You're all paid up",
    "noOutstanding": "No outstanding payments.",
    "history": "History",
    "paidOn": "Paid {date}",
    "cancelledStatus": "Cancelled",
    "noHistory": "No payment history yet.",
    "paymentLabel": "Payment"
  },
  "events": {
    "eventFallback": "Event",
    "notRegistered": "Not registered",
    "pendingApproval": "Pending approval",
    "confirmed": "Confirmed",
    "notApproved": "Not approved",
    "paid": "Paid",
    "paymentDue": "Payment due",
    "noEvents": "No events",
    "noEventsMessage": "There are no events open to you right now."
  },
  "eventDetail": {
    "allEvents": "All events",
    "dateTbc": "Date to be confirmed",
    "eventDetails": "Event details",
    "photosVideos": "Photos & videos",
    "confirmedHeading": "You're confirmed",
    "feeAdded": "Your event fee has been added to your account.",
    "goToPayments": "Go to Payments",
    "feeTbd": "The school will let you know about any fee to pay.",
    "deniedNote": "Your request to take part wasn't approved. Please contact the school if you have questions.",
    "interestedNote": "You've registered your interest{fee}. The school will confirm your place.",
    "withdrawInterest": "Withdraw interest",
    "withdrawConfirm": "Withdraw your interest in this event?",
    "registrationClosed": "Registration for this event is closed.",
    "registerHeading": "Register your interest",
    "chooseOption": "Choose the option you're interested in:",
    "agreeWithDetails": "I have read the event details and agree to the conditions",
    "agreeNoDetails": "I agree to the event conditions",
    "registerInterest": "Register interest",
    "selectOption": "Select an option above."
  },
  "gallery": {
    "submitNote": "Add your own photos or videos — they'll be reviewed by the school before appearing in the gallery.",
    "dropLabel": "Drop photos or videos here, or click to submit",
    "noMedia": "No media yet",
    "noMediaMessage": "Approved photos and videos will appear here.",
    "noPhotos": "No photos yet",
    "noPhotosEvent": "There are no photo albums for this event yet.",
    "all": "All",
    "unfiled": "Unfiled",
    "filterBy": "Filter by",
    "lastUpdated": "Last updated",
    "dateTaken": "Date taken",
    "to": "to",
    "fromDate": "From date",
    "toDate": "To date",
    "clear": "Clear",
    "noAlbumsMatch": "No albums match",
    "noAlbumsMatchMessage": "Try a different date range or clear the filter.",
    "allAlbums": "All albums",
    "clearSelection": "Clear selection",
    "selectedCount": "{count} selected",
    "selectAll": "Select all ({count})",
    "download": "Download",
    "preparingZip": "Preparing ZIP",
    "emptyAlbum": "Empty album",
    "emptyAlbumMessage": "No approved media here yet.",
    "select": "Select",
    "openFull": "Open full",
    "close": "Close",
    "itemOne": "{count} item",
    "itemOther": "{count} items"
  },
  "profile": {
    "name": "Name",
    "email": "Email",
    "dateOfBirth": "Date of birth",
    "phone": "Phone",
    "emergencyContact": "Emergency contact",
    "emergencyPhone": "Emergency phone",
    "medicalNotes": "Medical notes"
  },
  "toast": {
    "paymentReceived": "Payment received — thank you!",
    "paymentCanceled": "Payment canceled",
    "interestRegistered": "Interest registered — the school will review your request.",
    "interestWithdrawn": "Interest withdrawn",
    "saved": "Saved",
    "photoUpdated": "Photo updated",
    "fetchFailed": "Couldn't fetch {name}",
    "downloadedOne": "Downloaded {count} item as {name}",
    "downloadedOther": "Downloaded {count} items as {name}",
    "downloadFailed": "Download failed: {message}",
    "submittedOne": "{count} item submitted for approval",
    "submittedOther": "{count} items submitted for approval",
    "failedSuffix": ", {count} failed",
    "skippedUnsupported": "Skipped \"{name}\" — unsupported type"
  }
}
